import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable} from 'mobx';
import ReactPlayer from 'react-player';
import Close from 'react-icons/lib/md/close';
import SvgIcon from '@material-ui/core/SvgIcon';
import Minimize from '../../../assets/images/minimize-icon';
import Expand from '../../../assets/images/expand-icon';
import DialogWrapper from '../../../components/dialog/Dialog';
import {setUserProperties} from "../../../utils/userUtility";
import {DialogTypes} from '../../../constants/enums';

const videoUrl = 'https://www.youtube.com/watch?v=AuiAQwD0ObY&t=';

@inject('dialogStore', 'onBoardingStore')
@observer
class DiscoverVideoDialog extends Component {
    @observable isMinimized = false;

    @action toggleSize = () => {
        this.isMinimized = !this.isMinimized;
    };

    handleClose = () => {
        setUserProperties({discoverVideo: true});
        this.props.onBoardingStore.setDiscoverVideo(true);
        this.props.dialogStore.closeDialog(DialogTypes.DiscoverVideo);
    };

    render() {
        const {dialogStore, onBoardingStore} = this.props;

        return (
            <DialogWrapper
                disableBackdropClick={true}
                BackdropProps={{classes: {root: 'discover-video-overlay'}}}
                className={`discover-video ${this.isMinimized ? 'mini-dialog' : ''}`}
                classes={{scrollPaper: 'discover-video-scroll-paper', paper: 'discover-video-paper'}}
                open={dialogStore.getDialogState(DialogTypes.DiscoverVideo) && !onBoardingStore.discoverVideo}
                onClose={this.handleClose}>
                <div className="discover-video-wrapper">
                    <div className="discover-video-header">
                        <SvgIcon
                            viewBox="0 0 36 36"
                            className="discover-video-minimize"
                            onClick={this.toggleSize}>{this.isMinimized ? Expand : Minimize}</SvgIcon>
                        <Close
                            className="discover-video-close"
                            onClick={this.handleClose} />
                    </div>
                    <div className="discover-video-body">
                        <div className="discover-video-placeholder">
                            <ReactPlayer
                                className="discover-video-player"
                                url={videoUrl}
                                onEnded={this.handleClose}
                                controls={true}
                                playing={true}
                                width="100%"
                                height="100%"
                            />
                        </div>
                    </div>
                </div>
            </DialogWrapper>
        );
    }
}

export default DiscoverVideoDialog;
